// 自定义列信息
export const customColumns = [
  {
    key: 'aggregation_info',
    children: [
      {
        key: 'budget_name',
        isSelected: true,
      } 
    ]
  },
  {
    key: 'product_info',
    children: [
      {
        key: 'product_name',
        isSelected: true,
      }
    ]
  }
];

// 固定显示的表格列
export const fixedColumns = [
  {
    key: 'date',
  },
  // {
  //   key: 'budget_name',
  //   isSelected: true,
  // },
  // {
  //   key: 'product_name',
  //   isSelected: true,
  // },
  {
    key: 'product_series_name',
    isSelected: true,
  },
  {
    key: 'cost_total',
    isSelected: true,
    isHover: true,
  },
  {
    key: 'cost_cash',
    isSelected: true,
    isHover: true,
  },
  {
    key: 'cost_coupon',
    isSelected: true,
    isHover: true,
  },
];

// 折线图指标
export const fields = [
  // 'served_request',
  // 'impression_total',
  // 'click_total',
  'cost_total',
  'cost_cash',
  'cost_coupon',
];

export const fieldWithDiff = [
];
